var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectYourAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "236px",
    height: "179px",
    viewBox: "0 0 236 179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ADD6C676-4A43-4BC0-85E0-36792FC9E3C9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.453125,49 C83.4729167,49 78.625,53.7010101 78.625,59.5 L78.6311875,59.8575651 L78.6415,60.06 L78.5849691,60.0669738 C76.1964214,60.3681089 74.0797963,61.6680459 72.7675338,63.5964377 L72.7045938,63.694 L72.3783219,63.5774998 C71.2477726,63.1971556 70.0518882,63 68.828125,63 C62.8479167,63 58,67.7010101 58,73.5 C58,79.2989899 62.8479167,84 68.828125,84 L69.1208578,83.9962112 C73.9856717,83.870171 107.191667,84 113.171875,84 C119.152083,84 124,79.2989899 124,73.5 L123.996108,73.2157049 C123.848516,67.8315202 119.521139,63.4576128 114.045543,63.0336825 L113.6875,63.012 L113.6875,63 C113.6875,58.581722 109.993849,55 105.4375,55 L105.126771,55.0055989 C103.268482,55.0726458 101.5242,55.7393352 100.137153,56.869599 L99.9749687,57.007 L99.9347786,56.8542383 C98.7170076,52.2969326 94.4459865,49 89.453125,49 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.0%",
    y: "-11.4%",
    width: "109.1%",
    height: "117.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.77254902   0 0 0 0 0.8   0 0 0 0 0.843137255  0 0 0 1 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Channel-manager---Empty-state",
    transform: "translate(-618.000000, -271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(607.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.747266,211.172208 C228.261731,211.172208 246.237,168.721503 246.237,108.974528 C246.237,49.2275523 116.896562,21 64.2732454,21 C11.6499287,21 10.6949107,93.2756575 24.5621277,123.726546 C38.4293446,154.177435 67.2328007,211.172208 147.747266,211.172208 Z",
    id: "Oval",
    fill: "#F8F9FC",
    transform: "translate(131.618500, 116.086104) rotate(-11.000000) translate(-131.618500, -116.086104) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(34.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(152.000000, 20.000000)",
    stroke: "#788999"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1647727,12.0040357 L14.4886364,13.3985733 L13.9090909,20.1331695 L14.625,19.8950777 L17.3693182,11.0856816 L21.4943182,9.91222927 C22.0227273,9.74216371 22.5511364,9.4360457 22.9090909,9.19795391 C22.7727273,8.84081623 22.6363636,8.48367856 22.4659091,8.12654088 C22.0397727,8.12654088 21.4943182,8.16055399 21.0170455,8.27959988 L16.9090909,9.45305226 L9.92045455,3.41572482 L9.1875,3.60279693 L13.2613636,9.0108818 L13.7386364,10.3543997 L9.85227273,11.4598259 L-5.9472427e-13,14.8781437 C0.0340909091,15.0822223 0.0681818182,15.286301 0.102272727,15.4903797 L10.2954545,13.1094618 L14.1647727,12.0040357 Z",
    id: "Path-Copy-9",
    fill: "#788999"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 172,
    cy: 72,
    r: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "H",
    stroke: "#788999",
    fill: "#788999",
    fillRule: "nonzero",
    points: "169.225225 77.5369369 169.225225 72.5783784 174.774775 72.5783784 174.774775 77.5369369 176 77.5369369 176 67 174.774775 67 174.774775 71.4828829 169.225225 71.4828829 169.225225 67 168 67 168 77.5369369"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 62.000000)",
    stroke: "#788999"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-19",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27066726,5.49977482 L5.63385424,6.0784114 L5.63385424,8.27138323 L3.81818182,8.27138323 L3.81818182,9.74163886 L5.58151676,9.74163886 L5.58151676,14.4615507 C5.58151676,16.7082712 6.32861484,17.6234604 8.15768636,17.6234604 C8.61463835,17.6248708 9.06972412,17.5635988 9.51083602,17.4412498 L9.58240469,17.4212543 L9.5622571,15.8989247 L9.43605993,15.944154 C9.16197386,16.0561793 8.87181001,16.1212651 8.57715582,16.1368123 C7.71818943,16.1368123 7.39841253,15.638833 7.39841253,14.3002956 L7.39841253,9.74163886 L9.49421615,9.74163886 L9.49421615,8.27138323 L7.39843033,8.27138323 L7.39843033,5.45454545 L7.27066726,5.49977482 Z",
    id: "Path",
    strokeWidth: 0.5,
    fill: "#788999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0753316,8.01743741 C14.0138777,7.99927039 12.9624232,8.2251618 12.0019836,8.67770649 L11.9439415,8.70474838 L11.9650227,10.3075484 L12.1111802,10.2256687 C12.8597871,9.76977823 13.7125898,9.5132628 14.5883464,9.48055926 C15.946731,9.48055926 16.7256959,10.2599515 16.7256959,11.6194296 L16.7256959,11.699006 L15.6530696,11.699006 C12.5638418,11.699006 10.8633431,12.8184034 10.8633431,14.8506555 C10.8633431,16.481449 12.0897636,17.6209922 13.8483045,17.6209922 C15.0310568,17.665112 16.1577301,17.115453 16.8513788,16.1559119 L16.8513788,17.4952442 L18.5489736,17.4952442 L18.5489736,11.8891222 C18.5489736,9.32012387 17.3809352,8.01743741 15.0753316,8.01743741 Z M16.7256959,13.5863205 C16.7256959,15.1827623 15.7665899,16.2121105 14.2808315,16.2121105 C13.879025,16.2425187 13.4829759,16.102352 13.1896419,15.8259249 C12.8963079,15.5494978 12.7327675,15.162328 12.7390573,14.7591994 C12.7390573,13.6361517 13.8120236,13.0181373 15.7606304,13.0181373 L16.7256959,13.0181373 L16.7256959,13.5863205 L16.7256959,13.5863205 Z",
    id: "Shape",
    strokeWidth: 0.5,
    fill: "#788999",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(50.000000, 1.000000)",
    stroke: "#788999"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-20",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6270692,15.8481637 C17.5283247,16.5864118 17.0346021,17.2252649 16.3433904,17.5094223 C16.0049515,17.6513006 15.638243,17.693784 15.2715345,17.6513006 C14.9191599,17.6088173 14.5663871,17.494994 14.2000768,17.2821766 C13.6920203,16.9980192 13.1843619,16.557956 12.5918948,15.9050753 C13.5228008,14.7548191 14.0869984,13.7043585 14.2988213,12.7677213 C14.3975658,12.3276581 14.4115015,11.9300782 14.3688981,11.5609542 C14.312757,11.2058576 14.1857429,10.8796177 13.9882538,10.5958611 C13.5510704,9.95660719 12.8176534,9.58748314 11.9998258,9.58748314 C11.1819982,9.58748314 10.4485812,9.97103549 10.0113978,10.5958611 C9.81390872,10.8796177 9.68689459,11.2058576 9.63035539,11.5609542 C9.57381618,11.9300782 9.58815007,12.3416856 9.70083031,12.7677213 C9.91265324,13.7043585 10.4907865,14.7692474 11.4073587,15.9195036 C10.8292254,16.5723843 10.3072332,17.0120467 9.79957483,17.2962041 C9.43286634,17.5094223 9.08049172,17.6228448 8.72771895,17.6653281 C8.34707473,17.7082123 7.98036624,17.6513006 7.65586306,17.5234498 C6.96504956,17.2396932 6.47132694,16.6008401 6.37258241,15.8621912 C6.32997893,15.5074955 6.35824853,15.1527997 6.49959654,14.7548191 C6.54180186,14.6133416 6.61227678,14.4710625 6.6827517,14.3011291 C6.78149623,14.0734826 6.89417647,13.8326101 7.00725488,13.5909361 L7.0211906,13.5624802 C7.99430196,11.4475317 9.0382864,9.28969903 10.124078,7.18877799 L10.1662833,7.10341054 C10.2789636,6.8901923 10.392042,6.66334734 10.5047222,6.45052989 C10.6178006,6.22328413 10.7444166,6.01046668 10.8997003,5.82570427 C11.1959339,5.48503603 11.590912,5.3006744 12.0276972,5.3006744 C12.4652788,5.3006744 12.8602569,5.48503603 13.1560923,5.82570427 C13.3113761,6.01046668 13.4383902,6.22328413 13.5510704,6.45052989 C13.6637507,6.66334734 13.7768291,6.8901923 13.8895093,7.10341054 L13.9321128,7.18877799 C15.0039687,9.30372654 16.047555,11.4615592 17.0206663,13.5769086 L17.0206663,13.5909361 C17.1333466,13.8181818 17.2320911,14.0734826 17.3451695,14.3011291 C17.4156444,14.4710625 17.4861194,14.6133416 17.5283247,14.7548191 C17.6410049,15.1239431 17.6836084,15.4790397 17.6270692,15.8481637 L17.6270692,15.8481637 Z M11.9998258,15.1808548 C11.2381392,14.2157617 10.7444166,13.3071795 10.5751971,12.5404755 C10.5047222,12.2142356 10.4907865,11.9300782 10.5329918,11.6743767 C10.5612614,11.4475317 10.6456721,11.2487418 10.7587505,11.0784076 C11.0267144,10.6952561 11.4778336,10.4539828 11.9998258,10.4539828 C12.5214199,10.4539828 12.9868729,10.6808278 13.2409011,11.0784076 C13.3535814,11.2487418 13.4383902,11.4475317 13.4666598,11.6743767 C13.5088651,11.9300782 13.4949294,12.2282631 13.4240563,12.5404755 C13.255235,13.2927512 12.7615124,14.2017342 11.9998258,15.1808548 L11.9998258,15.1808548 Z M18.3604862,14.4426067 C18.2900113,14.2722725 18.2191382,14.0875101 18.1490614,13.9320051 C18.035983,13.6763035 17.9233028,13.4350303 17.8245582,13.2077845 L17.8102244,13.1933562 C16.837113,11.0639793 15.7935267,8.90614667 14.6934012,6.77676982 L14.6511959,6.69180315 C14.5385157,6.47858492 14.4254373,6.25173995 14.312757,6.0244942 C14.1718072,5.76919342 14.0308573,5.49906355 13.8047005,5.24376277 C13.3535814,4.67584878 12.7049732,4.36363636 12.0137615,4.36363636 C11.3086141,4.36363636 10.6739417,4.67584878 10.2084886,5.21530695 C9.99706388,5.47060773 9.84178015,5.7407376 9.70083031,5.99603838 C9.58815007,6.22328413 9.47507166,6.45052989 9.36239142,6.66334734 L9.32018609,6.748314 C8.23399633,8.87769086 7.17647432,11.0359243 6.20336296,13.1653012 L6.18902908,13.1933562 C6.09028456,13.4206019 5.97760431,13.6618752 5.86452591,13.9175768 C5.79444915,14.0734826 5.72357606,14.2442175 5.65310114,14.4285791 C5.46994597,14.9540098 5.41340677,15.4505838 5.48388169,15.9615862 C5.63916542,17.026475 6.34431281,17.9210297 7.31742417,18.3182088 C7.68413267,18.4745154 8.06477688,18.5454545 8.45975498,18.5454545 C8.57243522,18.5454545 8.71378323,18.5310262 8.82646347,18.5169987 C9.29191649,18.4604879 9.77130523,18.3041813 10.2367583,18.0344522 C10.8148915,17.7082123 11.3651533,17.2396932 11.9858901,16.557956 C12.6062287,17.2396932 13.1704262,17.7082123 13.7346238,18.0344522 C14.2000768,18.3041813 14.6794655,18.4604879 15.1449185,18.5169987 C15.2575988,18.5310262 15.3985486,18.5454545 15.511627,18.5454545 C15.906207,18.5454545 16.3011851,18.4745154 16.6539578,18.3182088 C17.6410049,17.9210297 18.3322166,17.0120467 18.4875003,15.9615862 C18.6001806,15.4650121 18.5436414,14.9680373 18.3604862,14.4426067 L18.3604862,14.4426067 Z",
    id: "Fill-1-Copy",
    fill: "#788999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(7.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4888689,8.76557499 C16.9456149,8.06288877 17.373648,7.24726804 17.6957125,6.96619355 C18.0177771,6.68511906 18.3830833,6.48016891 18.8281179,6.35134311 L18.9159536,6.05226592 C16.3994723,6.04084485 15.0280211,6.02342287 14.8016,6 L14.7137642,6.35134311 C15.217356,6.38647742 15.6377977,6.50824794 15.8819801,6.62363402 C16.1261625,6.7390201 16.1683446,6.83323211 16.1683446,7.07145224 C16.1683446,7.23026565 16.0291529,7.52733692 15.7507696,7.96266605 C12.8421419,12.5144506 11.3845161,14.7595782 11.3778921,14.6980489 C11.2643512,13.6433799 11.0177819,11.353025 10.6381842,7.82698416 C10.6264727,7.73329267 10.620617,7.61032258 10.620617,7.4580739 C10.620617,7.03646217 10.7230921,6.75245982 10.9280422,6.60606686 C11.1329924,6.4596739 11.5048305,6.37476598 12.0435566,6.35134311 L12.1313924,6 L6.12342522,6 L6.03558944,6.35134311 C6.23468387,6.36305455 6.42499472,6.45674604 6.60652199,6.6324176 C6.78804927,6.80808915 6.90223578,7.08916364 6.94908152,7.47564106 L8.3368868,18.5253818 C8.48913548,18.5136704 8.71165279,18.5078147 9.00443871,18.5078147 C9.29722463,18.5078147 10.085926,18.5136704 10.2264633,18.5253818 L16.4888689,8.76557499 Z",
    id: "V",
    fill: "#788999",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(104.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-22",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28610865,12.2971485 C9.0268426,12.4544262 8.98358508,12.7695157 8.97660806,13.0386768 C8.97465449,13.8245312 8.97772438,14.6098515 8.97772438,15.3946378 C9.73459148,15.3906325 10.4925749,15.4002454 11.2505583,15.3927687 C11.7682532,15.3828887 12.2968322,15.1196022 12.541307,14.6720684 C12.9096936,13.9948931 12.8376908,13.040813 12.2078055,12.5251878 C11.6920642,12.1112992 10.9801291,12.163102 10.35136,12.1593637 C9.99692743,12.173783 9.60146995,12.1027544 9.28610865,12.2971485 Z M9.21494305,7.6316888 C9.00256257,7.81086253 8.9847014,8.09818136 8.97660806,8.35025291 C8.97465449,8.99778839 8.97856162,9.64452279 8.97660806,10.2920583 C9.6355178,10.289121 10.2944276,10.3006031 10.9533373,10.289121 C11.3476785,10.2816443 11.7450895,10.1168899 11.9864944,9.81221445 C12.4620481,9.19138147 12.4349772,8.1681419 11.75709,7.68909916 C11.2926995,7.36439683 10.689885,7.45518531 10.15098,7.44103299 C9.83673505,7.44850969 9.46109231,7.40071222 9.21494305,7.6316888 Z M6.54748885,6.72433805 C6.50451041,6.04796388 7.14918704,5.43781189 7.85023798,5.45490149 C8.91855925,5.45490149 9.98688052,5.45410041 11.0552018,5.45490149 C12.1076154,5.47786563 13.2211478,5.77399629 13.9648981,6.52300125 C15.1124783,7.65545402 15.0435454,9.66935611 13.860801,10.7558806 C13.7218187,10.8803142 13.5744641,10.9943339 13.4304584,11.1120919 C14.0391336,11.4044842 14.6028768,11.8269176 14.9062376,12.4247865 C15.4560268,13.4984937 15.3898846,14.8675306 14.68995,15.8659369 C13.9199661,16.959938 12.4891189,17.4234933 11.1615316,17.452332 C9.62435457,17.4571385 8.08634033,17.452332 6.54860518,17.4542012 C6.54748885,13.8779362 6.54944242,10.3016712 6.54748885,6.72433805 L6.54748885,6.72433805 Z",
    id: "Fill-23-Copy",
    fill: "#788999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4808073,15.3358518 C17.4194495,15.0467711 18.4857758,15.7896101 18.5363111,16.768129 C18.6337936,17.6285096 17.9388574,18.4763604 17.0695892,18.5339379 C16.2125811,18.6431263 15.3618525,17.9614447 15.287694,17.1031524 C15.1749613,16.3227239 15.7114137,15.5232024 16.4808073,15.3358518",
    id: "Fill-25-Copy",
    fill: "#788999"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,127 C76.1688382,125.364289 77.0689148,123.580361 77.70023,121.648217 C78.3315451,119.716072 78.6295269,117.833333 78.5941754,116 L106.405825,116 C106.338187,117.932145 106.603883,119.814884 107.202912,121.648217 C107.801942,123.48155 108.734304,125.265478 110,127 L75,127 Z",
    id: "Path",
    fill: "#C5CCD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2.66000009,
    fill: "#D8D8D8",
    x: 67,
    y: 128,
    width: 49,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2.66000009,
    fill: "#E7EAF3",
    x: 38,
    y: 33,
    width: 108,
    height: 82,
    rx: 7.98000026
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#FFFFFF",
    x: 42,
    y: 38,
    width: 99,
    height: 64,
    rx: 3.99000013
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#E7EAF3",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 133,
    y1: 73,
    x2: 160,
    y2: 73,
    id: "Line-29-Copy-11",
    stroke: "#788999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 74,
    x2: 50,
    y2: 74,
    id: "Line-29-Copy-12",
    stroke: "#788999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(37.000000, 74.000000) scale(-1, 1) translate(-37.000000, -74.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,48 C113.761424,48 116,45.7614237 116,43 L116,25 L116,25",
    id: "Line-29-Copy-13",
    stroke: "#788999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,55 L159,55 C161.761424,55 164,52.7614237 164,50 L164,44 L164,44",
    id: "Line-29-Copy-14",
    stroke: "#788999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,34 L90,34 C92.7614237,34 95,31.7614237 95,29 L95,20 L95,20",
    id: "Line-29-Copy-15",
    stroke: "#788999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(81.000000, 27.000000) rotate(-90.000000) translate(-81.000000, -27.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,72.5 L47.2058513,72.5 C44.4444276,72.5 42.2058513,70.2614237 42.2058513,67.5 L42.2058513,32.2058513 C42.2058513,29.6068814 40.0989699,27.5 37.5,27.5 L37.5,27.5 L37.5,27.5",
    id: "Line-29-Copy-16",
    stroke: "#788999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(42.500000, 50.000000) scale(1, -1) rotate(90.000000) translate(-42.500000, -50.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,100 L106,100 L106,112 C106,116.418278 102.418278,120 98,120 L86,120 C81.581722,120 78,116.418278 78,112 L78,100 L78,100 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4400001,90 L105.56,90 C106.907575,90 108,91.0924252 108,92.4400001 L108,95 C108,97.7614237 105.761424,100 103,100 L81,100 C78.2385763,100 76,97.7614237 76,95 L76,92.4400001 C76,91.0924252 77.0924252,90 78.4400001,90 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#C5CCD7",
    transform: "translate(92.000000, 95.000000) scale(1, -1) translate(-92.000000, -95.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,120 L96,120 L96,123.011156 C96,124.109564 95.1095642,125 94.011156,125 L89.988844,125 C88.8904358,125 88,124.109564 88,123.011156 L88,120 L88,120 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,73 C85.8807119,73 87,74.1192881 87,75.5 L87,90 L87,90 L82,90 L82,75.5 C82,74.1192881 83.1192881,73 84.5,73 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,73 C100.880712,73 102,74.1192881 102,75.5 L102,90 L102,90 L97,90 L97,75.5 C97,74.1192881 98.1192881,73 99.5,73 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8600004,125.900001 L91.8600004,135.634179 C91.8600004,142.408405 97.3515963,147.900001 104.125823,147.900001 L107.401317,147.900001 C113.229561,147.900001 118.892972,145.965537 123.503328,142.400001 C128.113684,138.834465 133.777095,136.900001 139.605339,136.900001 L142.022315,136.900001 C149.421938,136.900001 156.616881,139.329588 162.501709,143.815479 L167.86,147.900001 L167.86,147.900001",
    id: "Line-28",
    stroke: "#788999",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,101 L84.0137327,101 C84.0137327,103.636488 84.0137327,106.803155 84.0137327,110.5 C84.0137327,114.196845 87.261687,117.030178 93.7575956,119 L86,119 L85.7593502,118.995941 C82.0047834,118.869099 79,115.785452 79,112 L79,101 Z",
    id: "Path",
    fill: "#C5CCD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,89 L83,89 L83,75.5 C83,74.6715729 83.6715729,74 84.5,74 L84.5,89 Z",
    id: "Path",
    fill: "#E7EAF3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,89 L98,89 L98,75.5 C98,74.6715729 98.6715729,74 99.5,74 L99.5,89 Z",
    id: "Path",
    fill: "#E7EAF3",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectYourAccount);
export default __webpack_public_path__ + "static/media/connectYourAccount.46f7a93b3a9c07b34a64c44bcceb7546.svg";
export { ForwardRef as ReactComponent };